export const filterFieldsEnum = Object.freeze({
  ACTUAL_STATUS: "actual_status",
  ID: "id",
  SEVERITY: "severity",
  AI_ANALYST_PRIORITY: "ai_analyst_priority",
  AI_ANALYST_PRIORITY_DIRECTION: "ai_analyst_priority_direction",
  ANALYST_INSTANCE_ID: "analyst_instance_id",
  SOURCE: "source",
  DATASOURCE: "datasource",
  TITLE: "title",
  PLUGIN_TEXT: "plugin_text",
  SYSTEM_STATUS_KEY: "system_status_key",
});
